export default __webpack_public_path__ + "static/media/place.a8d5b8ea.svg";